'use client';

import React from 'react';
import { useFilters } from '@/context/FiltersContext';

export const OnSaleFilter: React.FC = () => {
  const { filters, updateFilter } = useFilters();
  const active = filters.onSale === true;

  return (
    <button
      type="button"
      onClick={() => updateFilter('onSale', active ? null : true)}
      className={`w-full text-left text-[10px] font-medium px-[8px] py-[4px] rounded-sm border transition-colors cursor-pointer tracking-[0.03em] ${
        active
          ? 'border-accent text-accent bg-accent-dim'
          : 'border-border text-text-muted hover:border-border-mid hover:text-text-secondary'
      }`}
    >
      For sale only
    </button>
  );
};
